import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BankAccountsRoutingModule } from './bank-accounts-routing.module';
import { AddEditUserBankInformationComponent } from './components/add-edit-user-bank-information/add-edit-user-bank-information.component';

import { FormsModule } from '@angular/forms'; 
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    AddEditUserBankInformationComponent
  ],
  imports: [
    CommonModule,
    BankAccountsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
  ], 
  exports:[
    AddEditUserBankInformationComponent
  ]
})
export class BankAccountsModule { }
